<template>
  <v-select
    v-model="selectedStatuses"
    :items="items"
    :label="label"
    :outlined="outlined"
    @change="onChange"
    multiple
    item-text="name"
    item-value="id"
    clearable
  ></v-select>
</template>

<script>
import { SERVICE_STATUSES_LIST } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";
export default {
  name: "service-status-multi-select",

  props: {
    label: {
      type: String,
      default: () => "Status",
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedStatuses: this.value ? [...this.value] : [],
    };
  },

  computed: {
    items() {
      return this.serviceStatuses && this.serviceStatuses.edges
        ? this.serviceStatuses.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.selectedStatuses = newVal ? [...newVal] : [];
    },
  },

  methods: {
    onChange() {
      this.$emit("input", [...this.selectedStatuses]);
      this.$emit("change", [...this.selectedStatuses]);
    },
  },

  apollo: {
    serviceStatuses: {
      query: SERVICE_STATUSES_LIST,
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ServiceStatusMultiSelect.vue